import { Column, Row } from 'src/shared/components/Semantic/all'
import { cn } from 'src/shared/components/ui/utils'
import { useIsAdmin } from 'src/shared/hooks/useIsAdmin'
import { useLocalization } from 'src/shared/hooks/useLocalization'

const formatOrderValue = (amount: number, locale: string) =>
  Math.round(amount).toLocaleString(locale === 'sv' ? 'sv-SE' : 'en-GB')

export const QuoteOrderValue = ({
  amount,
  size = 'md',
  showLabel = false,
  className,
}: {
  amount: number
  size?: 'sm' | 'md'
  showLabel?: boolean
  className?: string
}) => {
  const isAdmin = useIsAdmin()
  const { locale, t } = useLocalization()

  if (!isAdmin) return null
  if (!Number.isFinite(amount) || amount <= 0) return null

  const formatted = formatOrderValue(amount, locale)

  if (size === 'sm') {
    return (
      <span
        className={cn(
          'w-fit rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold tabular-nums text-emerald-700',
          className
        )}
      >
        {formatted} kr
      </span>
    )
  }

  return (
    <Column
      className={cn(
        'rounded-lg border border-emerald-200/80 bg-emerald-50/80 px-3 py-1.5',
        className
      )}
    >
      <Row className="items-baseline gap-1.5">
        <span className="text-lg font-semibold tabular-nums text-emerald-700">
          {formatted}
        </span>
        <span className="text-sm text-emerald-700/80">kr</span>
      </Row>
      {showLabel ? (
        <span className="text-xs text-emerald-700/70">
          {t('Order value', 'Ordervärde')}
        </span>
      ) : null}
    </Column>
  )
}
